// Script to initialize store settings in Firestore
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

// Initial store settings with Shippo configuration
const initialSettings = {
  // General Settings
  storeName: 'Master Collectors Forge',
  storeEmail: 'contact@mastercollectorsforge.com',
  storePhone: '(555) 123-4567',
  storeAddress: '123 Main St, Anytown, USA',
  businessHours: 'Mon-Fri: 9am-5pm, Sat: 10am-4pm, Sun: Closed',
  
  // Payment Settings
  acceptCreditCards: true,
  acceptPayPal: true,
  acceptCrypto: false,
  stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '',
  paypalClientId: '',
  
  // Shipping Settings
  enableShipping: true,
  defaultShippingMethod: 'standard',
  freeShippingEnabled: true,
  freeShippingThreshold: 75.00,
  shippoEnabled: true,
  defaultFromAddress: {
    name: 'Master Collectors Forge',
    street1: '123 Main St',
    city: 'Anytown',
    state: 'CA',
    zip: '90210',
    country: 'US',
    phone: '555-123-4567',
    email: 'shipping@mastercollectorsforge.com'
  },
  
  // Tax Settings
  enableTax: true,
  taxRate: 7.5,
  
  // Email Settings
  orderConfirmationTemplate: 'Thank you for your order! Your order #{{orderNumber}} has been received and is being processed.',
  shippingConfirmationTemplate: 'Your order #{{orderNumber}} has shipped! Track your package with tracking number {{trackingNumber}}.',
  
  // User Settings
  allowGuestCheckout: true,
  requireEmailVerification: false,
  
  // Security Settings
  enableTwoFactorAuth: false,
  passwordMinLength: 8,
  passwordRequireSpecialChar: true,
  
  // Created timestamp
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString()
};

// Function to initialize settings in Firestore
export const initializeSettings = async () => {
  try {
    // Reference to the settings document
    const settingsRef = doc(db, 'settings', 'storeSettings');
    
    // Set the document data
    await setDoc(settingsRef, initialSettings);
    
    console.log('Store settings initialized successfully');
    return true;
  } catch (error) {
    console.error('Error initializing store settings:', error);
    return false;
  }
};

export default initializeSettings;
